import Helpers from "./shared.helper";
import FacebookRoundIcon from "../assets/img/FacebookRound.svg";
import InstagramRoundIcon from "../assets/img/InstagramRound.svg";
import TwitterRoundIcon from "../assets/img/TwitterRound.svg";
import YoutubeRoundIcon from "../assets/img/YoutubeRound.svg";

const LOCAL_SOCIAL_ICON_FALLBACKS = {
  FACEBOOK: FacebookRoundIcon,
  INSTA: InstagramRoundIcon,
  INSTAGRAM: InstagramRoundIcon,
  TWITTER: TwitterRoundIcon,
  YOUTUBE: YoutubeRoundIcon,
};

export const resolveSocialIconUrl = (channelCode, lang) => {
  const themeUrl = Helpers.getSocialNetworkIcon(channelCode, lang);
  if (themeUrl) {
    return themeUrl;
  }

  const normalizedCode = String(channelCode || "").toUpperCase();
  return LOCAL_SOCIAL_ICON_FALLBACKS[normalizedCode] || "";
};
